import { Chip } from "@mui/material";
import { grey } from "@mui/material/colors";
import { OrganizationNicheStatus } from "schemas/dashboard";

export default function StatusChip({
  status,
}: {
  status: OrganizationNicheStatus;
}) {
  const statusName =
    status === OrganizationNicheStatus.active
      ? "ACTIVE"
      : status === OrganizationNicheStatus.pending
        ? "PENDING"
        : "PAUSED";
  const color =
    status === OrganizationNicheStatus.active
      ? "primary.main"
      : status === OrganizationNicheStatus.pending
        ? "secondary.main"
        : grey[500];
  return (
    <Chip
      size="small"
      variant="outlined"
      sx={{
        fontSize: 12,
        border: "none",
        px: 1,
        fontWeight: 500,
        color,
      }}
      label={statusName}
    />
  );
}
